import { Navigate } from "react-router-dom";
const Protected = ({ children }) => {
    if (sessionStorage.getItem("username") === null) {
        return <Navigate to="/" replace />;
    }
    return children;
};
export default Protected;